
import { atom } from 'jotai';
export const nextSessionAtom = atom<any>({
  status: 'unauthenticated',
  session: {}
})